// State of a pending service-worker update, kept apart from `register.ts` (which imports the
// virtual PWA module) so React components and tests can use it.

// Set right before the reload that activates a new service worker; the next page load shows
// the "Neue Version geladen" toast (`consumeUpdatedFlag`).
const UPDATED_FLAG = "zt-pwa-updated";

// A new worker took over but the page has not reloaded yet (a half-filled form must not be
// lost): the reload happens at the next client-side navigation or when the tab goes hidden.
let updatePending = false;

export function reloadForUpdate() {
  updatePending = false;
  try {
    sessionStorage.setItem(UPDATED_FLAG, "1");
  } catch {
    // Storage may be unavailable (private mode); the reload still happens.
  }
  window.location.reload();
}

export function markUpdatePending() {
  updatePending = true;
  if (document.visibilityState === "hidden") reloadForUpdate();
}

// Called on every route change (`PwaUpdateGate`) and when the tab goes hidden.
export function reloadIfUpdatePending(): boolean {
  if (!updatePending) return false;
  reloadForUpdate();
  return true;
}

// True once after a reload triggered by a service-worker update.
export function consumeUpdatedFlag(): boolean {
  try {
    if (sessionStorage.getItem(UPDATED_FLAG) !== "1") return false;
    sessionStorage.removeItem(UPDATED_FLAG);
    return true;
  } catch {
    return false;
  }
}
